import {
    GET_PEOPLE,
    FILTER_PEOPLE,
    CLEAR_PEOPLE,
    CLEAR_FILTERED,
    REQUEST_COMPARE_FAILED,
    REQUEST_COMPARE_PENDING,
    REQUEST_COMPARE_SUCCESS
} from "../actiontypes";

//! Composed URL For API
import ApiPath from "../utils/Apis/ApiPath";

//! PEOPLE REDUCER ACTION CREATORS
// Gets List For Search
export const getPeople = formValues => async (dispatch, getState) => {
    const { sessionId, companyId } = getState().user.user;

    let fName = formValues.firstName;
    let lName = formValues.lastName;
    let email = formValues.email;

    const type = "json";

    if (!fName) {
        fName = "";
    }
    if (!lName) {
        lName = "";
    }
    if (!email) {
        email = "";
    }

    fName = fName.replace(/\s/g, "");
    lName = lName.replace(/\s/g, "");
    email = email.replace(/\s/g, "");

    const baseURL = `${ApiPath.urlApi}/api/attendeeemail/getattendeesbywhatever?`;
    const response = await fetch(
        `${baseURL}db=${ApiPath.db}&fname=${fName}&lname=${lName}&email=${email}&type=${type}&SessionId=${sessionId}&CompId=${companyId}`
    );

    const responseParsed = await response.json();

    // Dispatch = Async
    dispatch({ type: GET_PEOPLE, payload: responseParsed });
};

// Filter Those With Active Cases
export const filterActiveCases = evt => async (dispatch, getState) => {
    // Check If Checkbox Is Checked
    if (evt.target.checked) {
        const { unfiltered } = getState().people;

        const peopleFiltered = unfiltered.filter(person => {
            return person.activeCases > 0;
        });

        // Dispatch = Async
        dispatch({ type: FILTER_PEOPLE, payload: peopleFiltered });
    } else {
        // If Function Is Async => Must Use Dispatch Instead Of Return
        dispatch({ type: CLEAR_FILTERED });
    }
};

// Clears People Array In State
export const clearPeople = () => {
    // Return = Sync
    return {
        type: CLEAR_PEOPLE
    };
};

// Compare Different Attendees. //* DIFFERENT WAY TO HANDLE ASYNC CALLS
export const compareAttendees =
    compareAttnums => async (dispatch, getState) => {
        dispatch({ type: REQUEST_COMPARE_PENDING });

        const { sessionId, companyId } = getState().user.user;

        const compareAttnumsFiltered = compareAttnums.map(attendee => {
            return attendee.attnum;
        });

        try {
            const response = await fetch(
                `${ApiPath.urlApi}/api/attendeeRecord/getAttendees?db=${ApiPath.db}&type=json&SessionId=${sessionId}&CompId=${companyId}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify([...compareAttnumsFiltered])
                }
            );
            const responseParsed = await response.json();
            dispatch({
                type: REQUEST_COMPARE_SUCCESS,
                payload: responseParsed
            });
        } catch (error) {
            dispatch({ type: REQUEST_COMPARE_FAILED, payload: error });
        }
    };
